// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-5649d56fa59908ea.js";
	if (chunkId === 9375) return "static/chunks/9375-12fa6b5f2abdf35f.js";
	if (chunkId === 9623) return "static/chunks/9623-6b80ce284a63cf78.js";
	if (chunkId === 7600) return "static/chunks/7600-2dd20410623119d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","308":"3cdc70be1181cf48","1117":"e2c68699c3b6135d","2140":"e055a8b197c649fa","2592":"d9029570c43b32bc","3156":"73e657ddec4a6d95","3688":"1b9c184f9acef629","4686":"115275b932ae91d1","9074":"94841c917729fc3e","9724":"96943211c83b5fbc"}[chunkId] + ".js";
};